/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { encryptStorage } from '../../../utils/EncryptStorage';
import DatosPersonalesTemplate from '../../components/templates/DatosPersonales';
import Botonera from '../../components/atoms/Footer';
import { TipoProducto } from '../../../utils/TipoProducto';
import { parametrosActions } from '../../../application/actions/parametros';
import { paisesActions } from '../../../application/actions/paises';
import ModalEncuestaAbandono from '../../components/organisms/ModalEncuestaAbandono';
import ModalRespuestaEncuesta from '../../components/organisms/ModalRespuestaEncuesta';
import ModalRevisaDatosRenta from '../../components/organisms/ModalRevisaDatosRenta';
import { isValidRut } from '../../../utils/index';
import TagManagerUtils from '../../../utils/TagManagerUtils';
import { properties } from '../../../utils/properties';
import { ofertaActions } from '../../../application/actions/oferta';
import { contratosActions } from '../../../application/actions/contratos';

import { verificacionActions } from '../../../application/actions/verificacion';
import tiposContrato from './tiposContrato';
import valoresFormularioLaboral from './valoresFormularioLaboral';

const Step2 = () => {
  const dispatch = useDispatch();

  const history = useHistory();

  const [tipoRespuesta, setTipoRespuesta] = useState('');
  const [openModalEncuestaAbandono, setOpenModalEncuestaAbandono] = useState(false);
  const [openModalRespuestaEncuesta, setOpenModalRespuestaEncuesta] = useState(false);
  const [openModalRevisaDatosRenta, setOpenModalRevisaDatosRenta] = useState(false);
  const [encuestaRespondida, setEncuestaRespondida] = useState(false);
  const [botonAvanzarDisabled, setBotonAvanzarDisabled] = useState(false);

  const [paises, setPaises] = useState({
    objetoPaises: [],
  });
  const [regionesState, setRegiones] = useState({
    objetoRegiones: [],
  });
  const [comunasState, setComunas] = useState({
    objetoComunas: [],
  });
  const [cargosState, setCargos] = useState({
    objetoCargos: [],
  });

  const [state, setState] = useState({
    menuPosition: 2,
    checkbock: false,
    arraydeBotones: [
      { nameUno: properties.pasos.paso2.aceptarButton, nameDos: properties.volverCoopeuch },
    ],
    arraydeContratos: [
      {
        text: 'CONTRATA',
        value: 1,
      },
      {
        text: 'HONORARIO',
        value: 2,
      },
      {
        text: 'INDEFINIDO',
        value: 3,
      },
      {
        text: 'PENSIONADO',
        value: 4,
      },
      {
        text: 'PLANTA',
        value: 6,
      },
      {
        text: 'PLAZO FIJO',
        value: 7,
      },
    ],
    antiguedadTrabajandoDependiente: [
      {
        text: ' Menos de un año',
        value: 1,
      },
      {
        text: 'Entre 1 y 2 años',
        value: 2,
      },
      {
        text: '2 años o más',
        value: 3,
      },
    ],
    antiguedadTrabajandoIndependiente: [
      {
        text: ' Menos de un año',
        value: 6,
      },
      {
        text: '1 año',
        value: 1,
      },
      {
        text: '2 años',
        value: 2,
      },
      {
        text: '3 años',
        value: 3,
      },
      {
        text: '4 años',
        value: 4,
      },
      {
        text: '5 años o más',
        value: 5,
      },
    ],
    conJuntoDeContratos: [],
    listaDeAntiguedadesDependiente: [],
    listaDeAntiguedadesIndependiente: [],
    estadoBotonAvanzar: false,
  });

  const [datosPersonales, setDatosPersonales] = useState({
    paiseSeleccionado: { codigo: '', descripcion: 'Seleccione' },
    regionSeleccionada: { codigo: '', descripcion: 'Seleccione' },
    comunaSeleccionada: { codigo: '', descripcion: 'Seleccione' },
    activarDatosLaboalres: false,
    textoAsistidoEmail: [{ type: 'assist', text: 'Aquí recibiras tu comprobante' }],
    formularioDatosPersonales: [
      {
        nombreCompleto: '',
        email: '',
        nuevoEmail: '',
        estadoEmail: 0,
        numeroDeCelular: '',
        estadoNumeroDeCelular: 0,
        pais: '',
        region: '',
        comuna: '',
        buscarSucursalCercana: false
      },
    ],
  });

  const [datosLaborales, setDatosLaborales] = useState({
    mostrarFormulario: false,
    estadoCheckboxTrabajador: false,
    estadoCheckboxIndependiente: false,
    checkBoxValue: '',
    cargoSeleccionado: { codigo: '', descripcion: 'Seleccione' },
    contratoSeleccionado: { codigo: '', descripcion: 'Seleccione' },
    contratoSeleccionadoInicial: { codigo: '', descripcion: 'Seleccione' },
    antiguedadTrabajador: { codigo: '', descripcion: 'Seleccione' },
    antiguedadTrabajadorIndependiente: { codigo: '', descripcion: 'Seleccione' },
    textoAsistidoCuantoGana: [{ type: 'assist', text: 'Ingresa la cifra exacta, sin redondear' }],
    textoAsistidoRut: [{ type: 'assist', text: 'Sin puntos y con guión' }],
    textoAsistidohaceCuentoTrabajas: [{ type: 'assist', text: 'Tiempo en tu actual trabajo' }],
    formularioTrabajadorDependiente: [
      {
        rutDependiente: '',
        rutDependienteInicial: '',
        contrato: '',
        contratoInicial: '',
        cargo: '',
        tiempoTrabajando: '',
        cuantoGanaAlMes: '',
      },
    ],
  });

  const [checkDataDatosPersonales, setCheckDataDatosPersonales] = useState({
    estadoInfo: false,
  });

  const [checkPais, setCheckPais] = useState({
    estado: false,
  });

  const [checkRegion, setCheckRegion] = useState({
    estado: false,
  });

  const [checkComuna, setCheckComuna] = useState({
    estado: false,
  });

  const autorizo = (e) => {
    const { formularioDatosPersonales } = datosPersonales;
    if (e === 'false') {
      formularioDatosPersonales[0].buscarSucursalCercana = true;
      setState({ ...state, checkbock: true });
    } else {
      formularioDatosPersonales[0].buscarSucursalCercana = false;
      setState({ ...state, checkbock: false });
    }
  };

  const storeDataVerificacion = useSelector((store) => store.entities.verificacion.response);
  const storeDataOferta = useSelector((store) => store.entities.oferta.response);
  const storeDataPaises = useSelector((store) => store.entities.paises.response);
  const storeDataRegiones = useSelector((store) => store.entities.parametros.response.region);
  const storeDataComunas = useSelector((store) => store.entities.parametros.response.comuna);
  const storeDataCargos = useSelector((store) => store.entities.parametros.response.cargo);
  const storeDataContratos = useSelector((store) => store.entities.contratos.response);

  useEffect(() => {
    try {
      localStorage.removeItem('_gc');
      if ('code' in storeDataVerificacion && storeDataVerificacion.code === -1) {
        window.localStorage.setItem('paso', '/datos-personales');
        history.push('/error-conexion');
      } else if ('code' in storeDataVerificacion && storeDataVerificacion.code === 0) {
        const { data } = storeDataVerificacion;
        const { formularioTrabajadorDependiente } = datosLaborales;
        formularioTrabajadorDependiente[0].contratoInicial = data.codigoTipoContrato;
        formularioTrabajadorDependiente[0].rutDependienteInicial = formularioTrabajadorDependiente[0].rutDependiente;
        setDatosLaborales({
          ...datosLaborales,
          formularioTrabajadorDependiente,
          contratoSeleccionado: { codigo: data.codigoTipoContrato, descripcion: data.nombreTipoContrato },
          contratoSeleccionadoInicial: { codigo: data.codigoTipoContrato, descripcion: data.nombreTipoContrato }
        })
      }
    } catch {
      window.location.replace('/');
    }
  }, [storeDataVerificacion]);
  
  useEffect(() => {
    if (storeDataVerificacion.length === 0) {
      dispatch(verificacionActions.verificacion({ trackId: window.localStorage.getItem('track_id') }));
    }
  }, []);

  const {
    menuPosition,
    arraydeBotones,
    antiguedadTrabajandoIndependiente,
    antiguedadTrabajandoDependiente,
    checkbock,
  } = state;

  const almacenarPaises = (obj) => {
    if (Object.keys(storeDataVerificacion).length) {
      const { data } = storeDataVerificacion;
      const { pais } = data;

      setPaises({ ...state, objetoPaises: obj });

      const filtroPaises = obj.filter(function (e) {
        return e.codigo === pais;
      });

      if (filtroPaises.length === 1) {
        const { formularioDatosPersonales } = datosPersonales;
        formularioDatosPersonales[0].pais = pais;
        setDatosPersonales({
          ...datosPersonales,
          paiseSeleccionado: {
            codigo: filtroPaises[0].codigo,
            descripcion: filtroPaises[0].descripcion,
          },
          formularioDatosPersonales,
        });
        setCheckPais({ estado: true });
      }
    }
  };

  const almacenarContratos = () => {
    const antiguedadDependiente = [];
    antiguedadTrabajandoDependiente.map(function (val) {
      antiguedadDependiente.push({ codigo: val.value.toString(), descripcion: val.text });
      return antiguedadDependiente;
    });

    const antiguedadIndependiente = [];
    antiguedadTrabajandoIndependiente.map(function (valor) {
      antiguedadIndependiente.push({ codigo: valor.value, descripcion: valor.text });
      return antiguedadIndependiente;
    });

    setState({
      ...state,
      listaDeAntiguedadesIndependiente: antiguedadIndependiente,
      listaDeAntiguedadesDependiente: antiguedadDependiente,
    });
  };

  const almacenarCargos = (cargosServicio) => {
    if (cargosServicio) {
      const { data } = cargosServicio;
      const { cargos } = data;
      setCargos({ ...state, objetoCargos: cargos });
    }
  };

  const almacenarRegiones = (regionesServicio) => {
    try {
      if (regionesServicio) {
        const { data } = regionesServicio;
        const { regiones } = data;
        setRegiones({ ...state, objetoRegiones: regiones });
      }
    } catch {
      window.localStorage.setItem('paso', '/datos-personales');
      history.push('/error-conexion');
    }
  };

  const almacenarComunas = (comunasServicio) => {
    if (comunasServicio) {
      const { data } = comunasServicio;
      const { comunas } = data;
      setComunas({ ...state, objetoComunas: comunas });
    }
  };

  const tiposDeContratos = (contratosServicio) => {
    tiposContrato(
      contratosServicio,
      storeDataVerificacion,
      datosLaborales,
      state,
      setState,
      setDatosLaborales
    );
  };

  const setTextoSocio = () => {
    const { data } = storeDataVerificacion;
    const { socio, convenio } = data;
    let TextoSocio;
    if (socio && convenio) {
      TextoSocio = 'Socio convenio';
    } else if (socio) {
      TextoSocio = 'Socio';
    } else {
      TextoSocio = 'No Socio';
    }
    TagManagerUtils.vpvMetodo('vpv', '/solicitud-tarjeta-credito/paso2b', TextoSocio);
  }

  const overDatosPersonales = () => {
    const { formularioDatosPersonales } = datosPersonales;
    const { estadoEmail, estadoNumeroDeCelular, pais, region, comuna } = formularioDatosPersonales[0];
    const mostrarCard = estadoEmail + estadoNumeroDeCelular;
    if (mostrarCard  === 1 || mostrarCard === 0) {
      setDatosPersonales({ ...datosPersonales, activarDatosLaboalres: false });
    }
    if (mostrarCard === 2 && pais !== '' && region !== '' && comuna !== '') {
      setTextoSocio();
      setDatosPersonales({
        ...datosPersonales,
        activarDatosLaboalres: true,
      });
    }
  };

  /* OBTENEMOS DATOS DEL FORMULARIO - LABORALES */

  const valoresFormularioLaborales = (valor, indice) => {
    valoresFormularioLaboral(
      valor,
      indice,
      datosPersonales,
      setDatosPersonales,
      datosLaborales,
      setDatosLaborales,
      antiguedadTrabajandoDependiente,
      checkDataDatosPersonales,
      setCheckDataDatosPersonales,
      overDatosPersonales
    );
  };

  const quePaisSeleccionamos = (e) => {
    if (quePaisSeleccionamos !== '') {
      const { formularioDatosPersonales } = datosPersonales;
      formularioDatosPersonales[0].pais = e.descripcion;
      setDatosPersonales({
        ...datosPersonales,
        paiseSeleccionado: { codigo: e.codigo, descripcion: e.descripcion },
        formularioDatosPersonales,
      });
      setCheckPais({ estado: true });
    } else {
      setCheckPais({ estado: false });
    }
  };

  const queRegionSeleccionamos = (e) => {
    try {
      const { formularioDatosPersonales } = datosPersonales;
      formularioDatosPersonales[0].region = e.codigo;
      formularioDatosPersonales[0].comuna = '';
      setDatosPersonales({
        ...datosPersonales,
        comunaSeleccionada: { codigo: '', descripcion: '' },
        regionSeleccionada: { codigo: e.codigo, descripcion: e.descripcion },
        formularioDatosPersonales,
      });
      dispatch(
        parametrosActions.parametrosServicio({ lista: 'comuna', parametro: `region=${e.codigo}` })
      );
      setCheckRegion({ estado: true });
      setCheckComuna({ estado: false });
    } catch (error) {
      setCheckRegion({ estado: false });
      setCheckComuna({ estado: false });
    }
  };

  const queComunaSeleccionamos = (e) => {
    try {
      const { formularioDatosPersonales } = datosPersonales;
      formularioDatosPersonales[0].comuna = e.codigo;
      const { estadoEmail, estadoNumeroDeCelular, pais, region } = formularioDatosPersonales[0];
      const mostrarCard = estadoEmail + estadoNumeroDeCelular;
      if (mostrarCard  === 1 || mostrarCard === 0) {
        setDatosPersonales({
          ...datosPersonales, 
          comunaSeleccionada: { codigo: e.codigo, descripcion: e.descripcion },
          formularioDatosPersonales,
          activarDatosLaboalres: false
        });
      }
      if (mostrarCard === 2 && pais !== '' && region !== '' && e.codigo !== '') {
        setTextoSocio();
        setDatosPersonales({
          ...datosPersonales,
          comunaSeleccionada: { codigo: e.codigo, descripcion: e.descripcion },
          formularioDatosPersonales,
          activarDatosLaboalres: true,
        });
      }
      dispatch(parametrosActions.parametrosServicio({ lista: 'cargo' }));
      dispatch(contratosActions.contratos());
      setCheckComuna({ estado: true });
    } catch (error) {
      setCheckComuna({ estado: false });
    }
  };

  const activarDatosLaboralesPais = () => {
    setDatosPersonales({ ...datosPersonales, activarDatosLaboalres: true });
  };
  const desactivarDatosLaboralesPais = () => {
    setDatosPersonales({ ...datosPersonales, activarDatosLaboalres: false });
  };
  useEffect(() => {
    const { formularioDatosPersonales } = datosPersonales;
    const { estadoEmail, estadoNumeroDeCelular } = formularioDatosPersonales[0];
    if (
      estadoEmail === 1 &&
      estadoNumeroDeCelular === 1 &&
      (checkPais.estado || formularioDatosPersonales[0].pais === 'CL') &&
      checkRegion.estado &&
      checkComuna.estado
    ) {
      activarDatosLaboralesPais();
    } else {
      desactivarDatosLaboralesPais();
    }
  }, [checkPais, checkRegion, checkComuna]);

  const valorCargoFormularioLaboral = (e) => {
    const { formularioTrabajadorDependiente } = datosLaborales;
    formularioTrabajadorDependiente[0].cargo = e.codigo;
    setDatosLaborales({
      ...datosLaborales,
      cargoSeleccionado: { codigo: e.codigo, descripcion: e.descripcion },
      formularioTrabajadorDependiente,
    });

    if (e.descripcion === 'PENSIONADO JUBILADO') {
      formularioTrabajadorDependiente[0].contrato = 5;
      setDatosLaborales({
        ...datosLaborales,
        contratoSeleccionado: { codigo: 5, descripcion: 'PENSIONADO' },
        cargoSeleccionado: { codigo: e.codigo, descripcion: e.descripcion },
        formularioTrabajadorDependiente,
      });
    }
  };

  const obtenemosContraFormularioDL = (e) => {
    // ¿Qué tipo de contrato tienes?
    const { formularioTrabajadorDependiente } = datosLaborales;
    formularioTrabajadorDependiente[0].contrato = e.codigo;
    setDatosLaborales({
      ...datosLaborales,
      contratoSeleccionado: { codigo: e.codigo, descripcion: e.descripcion },
      formularioTrabajadorDependiente,
    });

    const buscarCargo = (cadenaABuscar) => {
      const { data } = storeDataCargos;
      const { cargos } = data;
      const resultado = cargos.filter((cargo) => {
        return cargo.descripcion.includes(cadenaABuscar);
      });
      return resultado;
    };
    if (e.descripcion === 'PENSIONADO' && storeDataCargos && Object.keys(storeDataCargos).length > 0) {
      // busqueda del cargo
      const cargo = buscarCargo('PENSIONADO');
      // aqui debes cambiar el valor del campo cargo
      formularioTrabajadorDependiente[0].cargo = cargo[0].codigo;
      setDatosLaborales({
        ...datosLaborales,
        cargoSeleccionado: { codigo: cargo[0].codigo, descripcion: cargo[0].descripcion },
        contratoSeleccionado: { codigo: e.codigo, descripcion: e.descripcion },
        formularioTrabajadorDependiente,
      });
    }
  };

  const obtenemosTiempoLaboralFormularioDL = (e) => {
    const { formularioTrabajadorDependiente } = datosLaborales;
    formularioTrabajadorDependiente[0].tiempoTrabajando = e.codigo;

    setDatosLaborales({
      ...datosLaborales,
      antiguedadTrabajador: { codigo: e.codigo, descripcion: e.descripcion },
      formularioTrabajadorDependiente,
    });
  };

  const formularioEstado = (e) => {
    const { formularioTrabajadorDependiente, textoAsistidoCuantoGana } = datosLaborales;
    textoAsistidoCuantoGana[0].type = 'assist';
    textoAsistidoCuantoGana[0].text = 'Ingresa la cifra exacta, sin redondear';
    formularioTrabajadorDependiente[0].cargo = '';
    formularioTrabajadorDependiente[0].cuantoGanaAlMes = '';

    if (e === 'trabajador') {
      setDatosLaborales({
        ...datosLaborales,
        estadoCheckboxTrabajador: true,
        estadoCheckboxIndependiente: false,
        mostrarFormulario: true,
        checkBoxValue: e,
        formularioTrabajadorDependiente,
        cargoSeleccionado: { codigo: '', descripcion: 'Selecciona' },
        textoAsistidoCuantoGana,
      });
    } else {
      setDatosLaborales({
        ...datosLaborales,
        estadoCheckboxTrabajador: false,
        estadoCheckboxIndependiente: true,
        mostrarFormulario: true,
        checkBoxValue: e,
        formularioTrabajadorDependiente,
      });
    }
  };

  useEffect(() => {
    dispatch(paisesActions.paisesServicio());
    dispatch(parametrosActions.parametrosServicio({ lista: 'region' }));
  }, []);

  useEffect(() => {
    if (storeDataPaises.length) {
      almacenarPaises(storeDataPaises);
      almacenarContratos();
    }
  }, [storeDataPaises]);

  useEffect(() => {
    almacenarRegiones(storeDataRegiones);
  }, [storeDataRegiones]);

  useEffect(() => {
    almacenarComunas(storeDataComunas);
  }, [storeDataComunas]);

  useEffect(() => {
    almacenarCargos(storeDataCargos);
  }, [storeDataCargos]);

  useEffect(() => {
    if (storeDataContratos) {
      tiposDeContratos(storeDataContratos);
    }
  }, [storeDataContratos]);

  // Enviamos datos al Servicio OFERTA

  const validarSiguienteStep = () => {
    const { formularioDatosPersonales } = datosPersonales;
    const { formularioTrabajadorDependiente, checkBoxValue } = datosLaborales;

    const { rutDependiente, contrato, cargo, tiempoTrabajando, cuantoGanaAlMes } =
      formularioTrabajadorDependiente[0];
    const { nombreCompleto, email, numeroDeCelular, pais, comuna } = formularioDatosPersonales[0];

    const removorDod = cuantoGanaAlMes.replaceAll('.', '');

    if (checkBoxValue === 'trabajador') {
      if (
        nombreCompleto !== '' &&
        email !== '' &&
        numeroDeCelular !== '' &&
        pais !== '' &&
        isValidRut(rutDependiente) &&
        contrato !== '' &&
        cargo !== '' &&
        tiempoTrabajando !== '' &&
        removorDod > 100000 &&
        comuna !== ''
      ) {
        setState({ ...state, estadoBotonAvanzar: true });
      } else {
        setState({ ...state, estadoBotonAvanzar: false });
      }
    }

    if (checkBoxValue === 'dependiente') {
      if (
        nombreCompleto !== '' &&
        email !== '' &&
        numeroDeCelular !== '' &&
        pais !== '' &&
        tiempoTrabajando !== '' &&
        removorDod > 100000 &&
        comuna !== ''
      ) {
        setState({ ...state, estadoBotonAvanzar: true });
      } else {
        setState({ ...state, estadoBotonAvanzar: false });
      }
    }
  };

  const volverACoopeuch = () => {
    window.location.href = properties.urlCoopeuch;
    const { data } = storeDataVerificacion;
    const { socio, convenio } = data;

    if (socio && convenio) {
      const TextoSocio = 'Socio convenio';
      TagManagerUtils.triggerEventMetodo(
        'trigger_event',
        TextoSocio,
        '/datos-personales',
        'Click',
        'Volver a coopeuch.cl'
      );
    } else if (socio) {
      const TextoSocio = 'Socio';
      TagManagerUtils.triggerEventMetodo(
        'trigger_event',
        TextoSocio,
        '/datos-personales',
        'Click',
        'Volver a coopeuch.cl'
      );
    } else {
      const TextoSocio = 'No Socio';
      TagManagerUtils.triggerEventMetodo(
        'trigger_event',
        TextoSocio,
        '/datos-personales',
        'Click',
        'Volver a coopeuch.cl'
      );
    }
  };

  const siguienteStep = () => {
    setOpenModalRevisaDatosRenta(false);
    setBotonAvanzarDisabled(true);
    const { formularioDatosPersonales } = datosPersonales;
    const { formularioTrabajadorDependiente, checkBoxValue } = datosLaborales;
    const { data } = storeDataVerificacion;
    const { socio, convenio } = data;
    const bodyData = {
      formularioDatosPersonales,
      formularioTrabajadorDependiente,
      checkBoxValue,
    };
    dispatch(ofertaActions.ofertaCreate({ infoFormulario: bodyData, verificacionInfo: data }));
    let TextoSocio;
    if (socio && convenio) {
      TextoSocio = 'Socio convenio';
    } else if (socio) {
      TextoSocio = 'Socio';
    } else {
      TextoSocio = 'No Socio';
    }
    TagManagerUtils.triggerEventMetodo(
      'trigger_event',
      TextoSocio,
      '/solicitud-tarjeta-credito/paso2',
      'Click',
      'Continuar y ver tarjeta'
    );
  };

  /** Activamos btn para avanzar, todo depende de que los campos en el state de datos personales y laborales no esten vacios */

  useEffect(() => {
    validarSiguienteStep();
  }, [datosLaborales, datosPersonales]);

  const urlFuturaTarjeta = () => {
    const { data } = storeDataOferta;
    const { tipoTarjeta } = data;
    let nuevoPath = '';
    if (tipoTarjeta === TipoProducto.black) {
      nuevoPath = '/tu-futura-tarjeta/mastercard/black';
      encryptStorage.setItem('p', nuevoPath);
      history.push(nuevoPath);
    } else {
      nuevoPath = '/tu-futura-tarjeta/mastercard/gold';
      encryptStorage.setItem('p', nuevoPath);
      history.push(nuevoPath);
    }
  };

  useEffect(() => {
    const { code } = storeDataOferta;
    if (code !== undefined) {
      let nuevoPath = '/';
      switch (code) {
        case -1:
          window.localStorage.setItem('paso', '/datos-personales');
          history.push('/error-conexion');
          break;
        case 0:
          urlFuturaTarjeta();
          break;
        case 11:
          // No se logro obtener la respuesta del servicio wsListaNegra.
          encryptStorage.setItem('p', nuevoPath);
          history.push('/datos-personales/error');
          break;
        case 12:
          // Cliente esta en lista negra
          encryptStorage.setItem('p', nuevoPath);
          history.push('/datos-personales/error');
          break;
        case 13:
          // Cliente es independiente
          nuevoPath = '/tu-futura-tarjeta/dale';
          encryptStorage.setItem('p', nuevoPath);
          history.push(nuevoPath);
          break;
        case 14:
          // Cliente con renta inferior a $400.000
          nuevoPath = '/tu-futura-tarjeta/dale';
          encryptStorage.setItem('p', nuevoPath);
          history.push(nuevoPath);
          break;
        case 15:
          // Cliente con antiguedad laboral inferior a 1 anio
          nuevoPath = '/tu-futura-tarjeta/dale';
          encryptStorage.setItem('p', nuevoPath);
          history.push(nuevoPath);
          break;
        case 16:
          // No se logro obtener la respuesta del servicio motor de riesgo
          encryptStorage.setItem('p', nuevoPath);
          history.push('/datos-personales/error');
          break;
        case 17:
          // Cliente es rechazado por el motor de riesgo
          nuevoPath = '/tu-futura-tarjeta/dale';
          encryptStorage.setItem('p', nuevoPath);
          history.push(nuevoPath);
          break;
        default:
          encryptStorage.setItem('p', nuevoPath);
          history.push('/datos-personales/error');
          break;
      }
    }
  }, [storeDataOferta]);

  const retomarEncuesta = () => {
    setOpenModalEncuestaAbandono(true);
    setOpenModalRespuestaEncuesta(false);
  }

  const handleSiguienteStep = () => {
    setOpenModalRevisaDatosRenta(true);
  }

  const { objetoPaises } = paises;
  const { objetoRegiones } = regionesState;
  const { objetoComunas } = comunasState;
  const { objetoCargos } = cargosState;
  const {
    estadoBotonAvanzar,
    conJuntoDeContratos,
    listaDeAntiguedadesDependiente,
    listaDeAntiguedadesIndependiente,
  } = state;
  const { estadoInfo } = checkDataDatosPersonales;
  const { data } = storeDataVerificacion;

  return (
    <>
      {data &&
        <>
          <DatosPersonalesTemplate
            activeMenu={menuPosition}
            listacontrato={conJuntoDeContratos}
            listaAno={listaDeAntiguedadesDependiente}
            independienteTiempo={listaDeAntiguedadesIndependiente}
            listaPaises={objetoPaises}
            listaRegiones={objetoRegiones}
            listaComunas={objetoComunas}
            listaCargos={objetoCargos}
            infoDatosPersonales={data}
            obtenerValoresDatosLaborales={valoresFormularioLaborales}
            obtenemosContratoDL={obtenemosContraFormularioDL}
            obtenemosTiempoTrabajandoDL={obtenemosTiempoLaboralFormularioDL}
            obtenerPaisDatosPersonales={quePaisSeleccionamos}
            obtenerRegionDatosPersonales={queRegionSeleccionamos}
            obtenerComunaDatosPersonales={queComunaSeleccionamos}
            valorCargoDatosLaborales={valorCargoFormularioLaboral}
            cambioEstadoFormularioDatosLadorales={formularioEstado}
            overFormularioLaborales={overDatosPersonales}
            obtenerCargoDatosLaborales={valorCargoFormularioLaboral}
            dataDatosPersonales={datosPersonales}
            dataDatosLaborales={datosLaborales}
            autorizoFunction={(t) => autorizo(t)}
            setAutorizo={checkbock}
          />
          <Botonera
            tituloboton={arraydeBotones}
            estadoBotonUno={estadoBotonAvanzar && estadoInfo}
            verificarFunction={() =>  handleSiguienteStep()}
            volverHome={process.env.REACT_APP_HABILITAR_ENCUESTAS === 'true' ? setOpenModalEncuestaAbandono : volverACoopeuch}
            estadoBotonDos={false}
            nombreDinamicoResponsive={false}
            activeMenu={menuPosition}
          />
          {openModalEncuestaAbandono && (
            <ModalEncuestaAbandono
              setTipoRespuesta={setTipoRespuesta}
              setOpenModalEncuestaAbandono={setOpenModalEncuestaAbandono}
              setOpenModalRespuestaEncuesta={setOpenModalRespuestaEncuesta}
              setEncuestaRespondida={setEncuestaRespondida}
            />
          )}
          {openModalRespuestaEncuesta && encuestaRespondida && (tipoRespuesta === 'exito' || tipoRespuesta === 'error') && (
            <ModalRespuestaEncuesta
              tipoRespuesta={tipoRespuesta}
              setOpenModalRespuestaEncuesta={setOpenModalRespuestaEncuesta}
              titulo={tipoRespuesta === 'exito' ? properties.encuestaAbandono.exitoTitulo : properties.encuestaAbandono.errorTitulo}
              descripcion={tipoRespuesta === 'exito' ? properties.encuestaAbandono.exitoDescripcion : properties.encuestaAbandono.errorDescripcion}
              botonAccion={tipoRespuesta === 'exito' ? volverACoopeuch : retomarEncuesta}
              botonTexto={tipoRespuesta === 'exito' ? properties.encuestaAbandono.exitoBoton : properties.encuestaAbandono.errorBoton}
            />
          )}
          {openModalRevisaDatosRenta &&
          <ModalRevisaDatosRenta
            setOpenModalRevisaDatosRenta={setOpenModalRevisaDatosRenta}
            siguienteStep={siguienteStep}
            estadoBotonAvanzar={botonAvanzarDisabled}
          />}
        </>}
    </>
  );
};
export default Step2;
